// extracted by mini-css-extract-plugin
module.exports = {"table":"Analysis_table__2Q6pW"};